export interface ClientDto {
  id: string;
  name: string;
  name_EN: string;
  description: string;
  description_EN: string;
  redirectUri: string;
  logoutUri: string;
  logoUrl: string;
  isLocal: boolean;
  permissionPrefix: string;
  orderIndex: number;
}

export enum ActionModeEnum {
  details = 1,
  edit = 2,
  create = 3,
}
